document.addEventListener("DOMContentLoaded", () => {
    if (window.location.href.includes('/products')) {
        const time = setInterval(() => {
            const dpoContainer = document.querySelector(".dpo-container");
            const targetElement = document.querySelector(".MAIN_CUSTOMIZE_DINNER_SET_TEMPLATE .block-offer.offer--custom.an-offer + .form-blocks.form-blocks.no-pad.clearfix");
            if (dpoContainer && dpoContainer.innerHTML !== "") {
                if (targetElement) {
                    setTimeout(()=>{
                        targetElement.classList.add("open_active_buy_button");
                        console.log("Interval is Cleared and Button is Added");
                    }, 2000)
                }
                clearInterval(time);
            }
        }, 2000);
    }
});
